/**
 * Aligné sur l’API `User.hasRole('admin')` pour le JSON de GET /user/me (`role` + `secondaryRoles`).
 */
export function userHasAdminAccess(user) {
  if (!user || typeof user !== "object") return false;
  const primary = user.role != null ? String(user.role).trim().toLowerCase() : "";
  if (primary === "admin") return true;
  const sec = user.secondaryRoles;
  if (!Array.isArray(sec)) return false;
  return sec.some((x) => String(x).trim().toLowerCase() === "admin");
}
